const BROCHURE_FILE_NAME =
  "Signature-Homes-Meshraf-al-Majdiah-Brochure-01022026.pdf";

let hadEngagement = false;

export function markEngagement() {
  hadEngagement = true;
}

export function resetEngagement() {
  hadEngagement = false;
}

export function getHadEngagement() {
  return hadEngagement;
}

function pushEvent(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
}

export function getFormName(propertyName, source) {
  if (propertyName === "Contact Form") return "contact_us";
  if (propertyName === "Ramadan Offer") return "may_furniture_offer";
  if (propertyName === "N/A") return "not_found_feedback";
  if (propertyName) return "brochure_download";
  return source || "website";
}

export function countFilledFields(formData) {
  if (!formData) return 0;
  return Object.values(formData).filter((v) => String(v || "").trim() !== "")
    .length;
}

export function trackPageView(pagePath, pageTitle) {
  pushEvent("page_view", {
    page_path: pagePath,
    page_title: pageTitle || document.title,
  });
}

export function trackFileDownload({
  propertyName = "",
  linkLocation = "",
  fileName = BROCHURE_FILE_NAME,
} = {}) {
  markEngagement();
  pushEvent("file_download", {
    file_name: fileName,
    property_name: propertyName,
    link_location: linkLocation,
  });
}

export function trackGenerateLead({
  formName,
  propertyName = "",
  source = "",
} = {}) {
  markEngagement();
  pushEvent("generate_lead", {
    form_name: formName,
    property_name: propertyName,
    source,
  });
}

export function trackWhatsappClick(linkUrl) {
  markEngagement();
  pushEvent("whatsapp_click", {
    link_url: linkUrl,
    page_path: window.location.pathname,
  });
}

export function trackBrochureDialogOpen(propertyName, trigger) {
  markEngagement();
  pushEvent("brochure_dialog_open", {
    property_name: propertyName,
    trigger,
  });
}

export function trackBrochureDropOff(propertyName, fieldsFilled) {
  pushEvent("brochure_drop_off", {
    property_name: propertyName,
    fields_filled: fieldsFilled,
  });
}

export function trackFormStart(formName) {
  markEngagement();
  pushEvent("form_start", {
    form_name: formName,
    page_path: window.location.pathname,
  });
}

export function trackFormAbandon({
  formName,
  fieldsFilled,
  timeOnFormSeconds,
} = {}) {
  pushEvent("form_abandon", {
    form_name: formName,
    fields_filled: fieldsFilled,
    time_on_form_seconds: timeOnFormSeconds,
    page_path: window.location.pathname,
  });
}

export function trackScrollDepth(percentScrolled) {
  if (percentScrolled >= 25) {
    markEngagement();
  }
  pushEvent("scroll", {
    percent_scrolled: percentScrolled,
    page_path: window.location.pathname,
  });
}

export function trackPageExit({
  timeOnPageSeconds,
  maxScrollPercent,
  hadEngagement: engaged = getHadEngagement(),
} = {}) {
  pushEvent("page_exit", {
    time_on_page_seconds: timeOnPageSeconds,
    max_scroll_percent: maxScrollPercent,
    had_engagement: engaged,
    page_path: window.location.pathname,
  });
}

export { BROCHURE_FILE_NAME };
